import React, { FC } from 'react';

import { Icon } from '@column/column-ui-kit';
import { Input, cn } from '@column/ui';

import { useRoutingNumberInstitution } from './RoutingNumberInput';

interface RoutingNumberFieldProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  invalid?: boolean;
}

/** Routing number or BIC input that reveals the matching institution's name beneath it. */
export const RoutingNumberField: FC<RoutingNumberFieldProps> = ({ value, onChange, onBlur, invalid }) => {
  const { institution, checkRoutingNumber } = useRoutingNumberInstitution();
  const institutionName = institution?.fullName ?? institution?.shortName;

  return (
    <>
      <Input
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
          checkRoutingNumber(event.target.value);
        }}
        onBlur={onBlur}
        placeholder="Routing number"
        aria-invalid={invalid}
      />
      <div
        className={cn(
          'grid transition-[grid-template-rows,opacity] duration-200',
          institution ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        )}
      >
        <div className="min-h-0 overflow-hidden">
          <p className="mt-1.5 flex items-center gap-1 truncate text-xs leading-5 font-medium text-seafoam-600">
            <Icon.CircleCheck className="shrink-0 [--icon-size-x:16px] [--icon-size-y:16px]" />
            {institutionName}
          </p>
        </div>
      </div>
    </>
  );
};
